// import React from 'react';
import React, { useState } from 'react';

import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

import image01 from '../assets/CardsImages/card-1-img/img_1.jpg'
import image02 from '../assets/CardsImages/card-1-img/img_2.jpg'
import image03 from '../assets/CardsImages/card-1-img/img_3.jpg'
import image04 from '../assets/CardsImages/card-1-img/img_4.jpg'
import image05 from '../assets/CardsImages/card-1-img/img_5.jpg'
import image06 from '../assets/CardsImages/card-1-img/img_6.jpg'
import image07 from '../assets/CardsImages/card-1-img/img_7.jpg'
import image08 from '../assets/CardsImages/card-1-img/img_8.jpg'
import image09 from '../assets/CardsImages/card-1-img/img_9.jpg'
import image10 from '../assets/CardsImages/card-1-img/img_10.jpg'
import image11 from '../assets/CardsImages/card-1-img/img_15.jpg'
import image12 from '../assets/CardsImages/card-1-img/img_12.jpg'
import image13 from '../assets/CardsImages/card-1-img/img_10.jpg'
import image14 from '../assets/CardsImages/card-1-img/img_14.jpg'
import image15 from '../assets/CardsImages/card-1-img/img_15.jpg'
import image16 from '../assets/CardsImages/card-1-img/img_2.jpg'


const Card01 = () => {


    const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

    const images = [
        image01,
        image02,
        image03,
        image04,
        image05,
        image06,
        image07,
        image08,
        image09,
        image10,
        image11,
        image12,
        image13,
        image14,
        image15,
        image16


        // Add the rest of the images here...
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image); // Set the selected image
    };

    const handleClose = () => {
        setSelectedImage(null); // Clear the selected image
    };



    return (

        <div>
            {/* <Navbar /> */}
            <Hero />
            <div className="container mx-auto p-6 bg-gray-0 my-10">

                <section className="text-center mb-12">
                    <h2 className="text-3xl font-semibold text-purple-800 mb-4">Distillation Column Internal Revamp & Installation</h2>
                    <p className="text-lg text-blue-800">Revamp & Installation during Project & Shutdown Work to enhance efficiency, performance, and capacity.</p>
                </section>

                <section className="mb-12">
                    <h3 className="text-2xl font-semibold text-purple-800 mb-4">Key Steps in the Revamp Project</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">1. Project Planning</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Define project goals: capacity, efficiency, energy savings, safety.</li>
                                <li>Establish budget and timeline, including shutdown duration.</li>
                            </ul>
                        </div>
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">2. Engineering Design</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Collaborate with process engineers to develop plans for internals.</li>
                                <li>Ensure safety and environmental compliance with simulations.</li>
                            </ul>
                        </div>
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">3. Procurement</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Procure necessary materials and equipment.</li>
                                <li>Ensure the right components are sourced for a successful revamp.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="mb-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">4. Shutdown and Installation</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Carefully plan the shutdown to minimize downtime.</li>
                                <li>Install new internals, instrumentation, and other equipment.</li>
                            </ul>
                        </div>
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">5. Testing and Commissioning</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Test and commission the revamped column to ensure it meets design specifications.</li>
                                <li>Perform safety checks and inspections.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="mb-12">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">6. Operator Training</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Train operators to effectively use the new column.</li>
                                <li>Ensure safety and operational efficiency post-installation.</li>
                            </ul>
                        </div>
                        <div className="p-4 bg-white shadow-lg rounded-lg">
                            <h4 className="text-xl font-semibold text-purple-800 mb-2">7. Post-Revamp Evaluation</h4>
                            <ul className="list-disc pl-5 text-gray-700">
                                <li>Evaluate the column’s performance to meet objectives.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="mb-12">
                    <div className="p-4 bg-white shadow-lg rounded-lg">
                        <h3 className="text-2xl font-semibold text-purple-800 mb-4">8. Continuous Monitoring</h3>
                        <ul className="list-disc pl-5 text-gray-700 mb-4">
                            <li>Implement monitoring to ensure long-term efficiency.</li>
                            <li>Regular inspections and performance assessments.</li>
                        </ul>
                    </div>
                    <p className="text-lg text-purple-800 mt-8">
                        Distillation column revamps are complex projects requiring careful planning and execution. External expertise and safety measures are essential for success.
                    </p>
                </section>

                <section className="mb-12">
                    <h3 className="text-2xl  text-purple-800 mb-4 font-bold justify-center items-center text-center">All Work</h3>
                    <p className="text-lg text-gray-600 mb-4 justify-center items-center  text-center">
                        We provide high-standard work for your company’s distillation solutions, ensuring both efficiency and safety at every step.
                    </p>
                    {/* <div className="flex justify-center space-x-6">
                        <img src={image1} alt="Distillation Column Work" className="w-1/2 rounded-lg shadow-lg" />
                        <img src={image2} alt="Distillation Work Process" className="w-1/2 rounded-lg shadow-lg" />
                    </div> */}
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                            <div className="relative">
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    className="max-w-full max-h-screen rounded-lg"
                                />
                                <button
                                    onClick={handleClose}
                                    className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                                >
                                    ✖
                                </button>
                            </div>
                        </div>
                    )}


                </section>
            </div>
            {/* <Footer /> */}
        </div>
    );
}

export default Card01;
